import { GetReworkById, saveOrUpdateRework, AddProductForMaterialInward, GetMasterItemSelectbyIDVendorwiseRateForWoOrderRecv, GetTransactionMaterialJobWorkItemsSelectbyID, GetTransactionMaterialJobWorkSelectbyID, SubmitDeliveryChallanInsertUpdate, SubmitJobWorkInwardInsertUpdate, SubmitTransaction_SalesInvoiceInsertUpdate, USP_Extra_GatePassSelect_ForJobWorkInward, usp_Master_ItemCategorySelect, usp_Master_ItemSelectbyID_JobWork, usp_Master_ItemSelectbyIDCategory, usp_Master_PlantSelect, usp_Master_ProcessSelect, usp_Transaction_ChallanInvoiceCount, usp_Transaction_ChallanInvoiceItemsSelectbyId, usp_Transaction_ChallanInvoiceSelectbyId, usp_Transaction_ChallanInvoiceSelectForInvoice, usp_Transaction_MaterialJobWorkCOUNT, USP_Transaction_MaterialJobWorkInsertUpdate, usp_Transaction_MaterialJobWorkInwardCOUNT, USP_Transaction_MaterialJobWorkInwardItemsSelectbyID, USP_Transaction_MaterialJobWorkInwardSelectbyID, usp_Transaction_MaterialJobWorkSelectbyID_PendingQty, usp_Transaction_MaterialJobWorkSelectbyIDVendor2, usp_Transaction_MaterialRejectionSelect_ForDeliveryChallan, usp_Transaction_MaterialRejectionSelectbyId_PendingQty_ForChallan2, usp_Transaction_MaterialTestingCount, USP_Transaction_MaterialTestingInsertUpdate, USP_Transaction_MaterialTestingSelectbyId, usp_Transaction_PurchaseInwardSelectbyIDVendorNotInMaterialTesting, usp_Transaction_PurchaseInwardSelectIDVendorNotInMaterialTesting, usp_Transaction_SalesInvoiceCount, usp_Transaction_SalesInvoiceItemsSelectbyId, usp_Transaction_SalesInvoiceSelectbyId, USP_Transaction_WorkOrderRecvCount, USP_Transaction_WorkOrderRecvInsertUpdate, USP_Transaction_WorkOrderRecvSelectbyId, usp_Transaction_WorkOrderRecvSelectbyId_PendingQty, usp_Transaction_WorkOrderRecvSelectForSalesInvoicebyIDVendor, DownloadMaterialJobWorkInvoice, DownloadPendingMaterialJobWorkInvoice, DownloadWoOrderInvoice, DownloadPendingWoOrderInvoice, DownloadDeliveryChallanInvoice, usp_Transaction_MaterialRejectionCount, usp_Transaction_MaterialRejectionOutwardCount, usp_Transaction_MaterialRejectionSelect_ForOutward, usp_Transaction_MaterialRejectionItemSelect_ForOutward, usp_Transaction_MaterialRejectionItemSelect_ForOutward_ByMaterial, usp_Master_MaterialSelect_ForOutward, usp_Transaction_PurchaseInquiryOutwardCount, usp_Master_ItemSelect_ForPurchaseInquiryOutward, usp_Transaction_PurchaseInquirySelect_ForOutward_ByItem, USP_Transaction_PurchaseInquiryOutwardInsertUpdate, usp_Transaction_PurchaseInquiryOutwardSelectbyId, USP_Transaction_MaterialRejectionOutwardInsertUpdate, usp_Transaction_MaterialRejectionOutwardSelectbyId, usp_Master_PartyAccountSelectSupplier, usp_Master_ItemSelectForAuto, USP_Transaction_MaterialRejectionInsertUpdate, USP_Transaction_MaterialRejectionSelectbyId, usp_Transaction_SalesReturnCount, usp_Master_PartyAccountSelectCustomer, usp_Transaction_SalesInvoiceSelect_ForSalesReturn, USP_Transaction_SalesReturnInsertUpdate, USP_Transaction_SalesReturnSelectbyId, usp_Transaction_SalesReturnSelectbyId, usp_Transaction_MaterialJobWorkSelect_ForRework, usp_Master_ItemSelect, usp_Transaction_ReworkCount, usp_Transaction_MaterialJobWorkSelectByID, usp_Transaction_MaterialJobWorkItemSelectByIDMaterialJobWork, usp_Transaction_JobWorkQuantitySelectbyIDMaterialJobWorkItems, usp_Transaction_SalesReturnInwardCOUNT, USP_Transaction_SalesReturnSelectbyIDVendor, USP_Transaction_SalesReturnSelectbyID_PendingQty, SubmitSalesReturnInwardInsertUpdate, USP_Transaction_SalesReturnInwardSelectbyId, USP_Master_PartyAccountSelectCustomerForSalesReturnInward, getReworkBOMItems, GenerateReportForReworkProduct } from "../ApiEndPoints_1";
import {
    GetAllDropdownAndCountsForTransactionStock,
    USP_Master_ItemSelectbyItemType_Vendorwise,
    USP_Master_ItemSelectbyID_VendorwiseRate,
    USP_Transaction_PurchaseOrderInsertUpdate,
    USP_Transaction_PurchaseOrderSelectbyId,
    USP_Extra_GatePassSelect_ForPurchase,
    USP_Transaction_PurchaseInwardInsertUpdate,
    USP_Transaction_PurchaseInwardSelectbyId,
    usp_Transaction_PurchaseInquirySelectNotinPurchaseOrder2,
    USP_Transaction_PurchaseInquirySelectbyIDNotInPurchaseOrderItems2,
    USP_Master_ItemRateVendorwiseSelect3,
    USP_Transaction_PurchaseInquirySelectbyIDNotInPurchaseOrderItems,
    GetMaster_TaxStructure,
    USP_Transaction_PurchaseOrderSelectbyIDVendor,
    USP_Transaction_PurchaseOrderSelectbyID_PendingQty,
    USP_Master_PartyAccountSelectbyID_withGatePass,
    DownloadPurchaseInvoice,
    GeneratePendingPurchaseOrderInvoice,
    SendPurchaseInvoiceMail,
    ShareOnWhatsApp,
    DownloadJobWorkInwardInvoice,
    USP_Master_PartyAccountSelectCustomerForPlanning,
    usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning,
    USP_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning,
    USP_Transaction_WorkOrderProductsSelect,
    USP_Transaction_WorkOrderRecvProductsSelectbyId,
    USP_Master_ProductReceipeSelect_ForWOItem,
    USP_Master_ProductReceipeSelect_ForWOItem_ForExisitingItem,
    USP_Transaction_MaterialPlanningInsertUpdate,
    usp_Transaction_MaterialPlanningSelectbyId2,
    usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning2,
    usp_Transaction_MaterialPlanningSelectbyId,
    usp_Transaction_MaterialPlanning_MultipleInsertUpdate,
    usp_Transaction_MaterialPlanning_MultipleSelectByID,
    AddWoBomData,
    usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry,
    usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForPurchaseInquiry,
    usp_Transaction_PurchaseInquiryInsertUpdate,
    usp_Transaction_PurchaseInquirySelectbyId,
    usp_Transaction_WorkOrderRecvSelectForWorkPlanning,
    usp_Transaction_MaterialPlanningSelectbyIDWorkOrder,
    usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForWorkPlanning,
    USP_Transaction_WorkPlanningInsertUpdate,
    usp_Transaction_WorkPlanningSelectbyId,
    USP_Master_PartyAccountSelectCustomerForCalculatePlanning,
    usp_Transaction_MaterialProductionSelectNotinMaterialIssue,
    usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems,
    USP_Transaction_MaterialIssueInsertUpdate,
    usp_Transaction_MaterialIssueSelectbyId,
    usp_Transaction_WorkOrderRecvSelect_NotInMaterialProduction,
    usp_Transaction_WorkPlanningSelectNotinMaterialProduction,
    usp_Transaction_WorkPlannigSelectbyId_ForMaterialProduction,
    usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialProduction,
    usp_Transaction_WorkPlanningItemQuantitySelect_ForMaterialProduction,
    usp_Transaction_WorkOrderRecvItemQuantitySelect_ForMaterialProduction,
    usp_Master_ProductReceipeSelectbyIdforMaterialProduction,
    usp_Master_ProductReceipeSelectbyIdforMaterialProductionWO,
    usp_Transaction_MaterialProductionInsetUpdate,
    usp_Transaction_MaterialProductionSelectbyId,
    usp_Transaction_WorkPlanningSelect_Pending_WithNewChanges,
    usp_Transaction_MaterialProductionNoSelectNotinIssueProcessTransaction2,
    usp_Transaction_MaterialIssue_JobWorkSelectPendingItem,
    usp_Transaction_MaterialProductionItemQuantitySelect_ForMaterialIssueProcess,
    usp_Transaction_MaterialProduction_Serial_Select_ForAssembly,
    usp_Transaction_MaterialIssue_JobWorkSelectbyID,
    usp_Master_ProcessItemSelectbyIDItem,
    usp_Transaction_MaterialProduction_SerialNoSelectbyID,
    usp_Transaction_MaterialIssue_JobWorkInsertUpdate,
    usp_Transaction_StoreToPlantDataSelectByItemId,
    AddAllocatedQtyEmployeeWise,
    GetAllocatedQtyEmployeeWise,
    usp_Master_EmployeeSelect_ForIssueJobWorkProcessWise,
    GenerateMaterialPurchaseReport,
    usp_Transaction_IssueProcessTransactionCount,
    usp_Transaction_PurchaseOrderCount,
    downloadPendingMaterialJobWorkInvoice,
    usp_Transaction_MaterialIssue_JobWorkRecordDelete,
    usp_Transaction_JobworkInwardDelete,
    DownloadIssueProcessEmployeeReport
} from "../ApiEndPoints";
import { axiosGetAuthorize, axiosGetFileAuthorizeblob, axiosGetMultiParams, axiosPostAuthorize } from "../AxiosRequests";

export default class TransactionStockServices {

    // WO Order Receive
    async getInvoiceCountForWoOrderReceive(request) {
        return axiosGetAuthorize(USP_Transaction_WorkOrderRecvCount, request);
    }
    async getMasterItemSelectbyIDVendorwiseRateForWoOrderRecv(request) {
        return axiosGetMultiParams(GetMasterItemSelectbyIDVendorwiseRateForWoOrderRecv, request);
    }
    async submitWorkOrderRecv(request) {
        return axiosPostAuthorize(USP_Transaction_WorkOrderRecvInsertUpdate, request);
    }
    async getWorkOrderRecvSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_WorkOrderRecvSelectbyId, request);
    }
    async downloadWoOrderInvoice(request) {
        return axiosGetFileAuthorizeblob(DownloadWoOrderInvoice, request);
    }
    async DownloadPendingWoOrderInvoice(request) {
        return axiosGetFileAuthorizeblob(DownloadPendingWoOrderInvoice, request);
    }

    // Delivery Challan
    async getInvoiceCountForDeliveryChallan(request) {
        return axiosGetAuthorize(usp_Transaction_ChallanInvoiceCount, request);
    }

    async getWorkOrderSalesInvoiceByVendorIdforTaxInvoice(request) {
        return axiosPostAuthorize(usp_Transaction_WorkOrderRecvSelectForSalesInvoicebyIDVendor, request);
    }

    async getWorkOrderSalesInvoiceByVendorIdForRejection(request) {
        return axiosPostAuthorize(usp_Transaction_MaterialRejectionSelect_ForDeliveryChallan, request);
    }

    async workOrderRecvSelectbyId_PendingQty(request) {
        return axiosPostAuthorize(usp_Transaction_WorkOrderRecvSelectbyId_PendingQty, request);
    }

    async usp_Transaction_MaterialRejectionSelectbyId_PendingQty_ForChallan2(request) {
        return axiosPostAuthorize(usp_Transaction_MaterialRejectionSelectbyId_PendingQty_ForChallan2, request);
    }

    async submitDeliveryChallanInsertUpdate(request) {
        return axiosPostAuthorize(SubmitDeliveryChallanInsertUpdate, request);
    }

    async getTransactionDeliveryChallanByID(request) {
        return axiosGetAuthorize(usp_Transaction_ChallanInvoiceSelectbyId, request);
    }

    async getTransactionDeliveryChallanItemsByID(request) {
        return axiosGetAuthorize(usp_Transaction_ChallanInvoiceItemsSelectbyId, request);
    }
    async downloadDeliveryChallanInvoice(request) {
        return axiosGetFileAuthorizeblob(DownloadDeliveryChallanInvoice, request);
    }

    // Sales Invoice
    async usp_Transaction_ChallanInvoiceSelectForInvoice(request) {
        return axiosPostAuthorize(usp_Transaction_ChallanInvoiceSelectForInvoice, request);
    }

    async getInvoiceCountForSalesInvoice(request) {
        return axiosGetAuthorize(usp_Transaction_SalesInvoiceCount, request);
    }

    async submitTransaction_SalesInvoiceInsertUpdate(request) {
        return axiosPostAuthorize(SubmitTransaction_SalesInvoiceInsertUpdate, request);
    }

    async usp_Transaction_SalesInvoiceSelectbyId(request) {
        return axiosGetAuthorize(usp_Transaction_SalesInvoiceSelectbyId, request);
    }

    async usp_Transaction_SalesInvoiceItemsSelectbyId(request) {
        return axiosGetAuthorize(usp_Transaction_SalesInvoiceItemsSelectbyId, request);
    }

    // Material Job Work
    async getInvoiceCountForMaterialJobWork(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialJobWorkCOUNT, request);
    }

    async usp_Master_ItemCategorySelect(request) {
        return axiosGetAuthorize(usp_Master_ItemCategorySelect, request);
    }

    async usp_Master_PlantSelect(request) {
        return axiosGetAuthorize(usp_Master_PlantSelect, request);
    }

    async usp_Master_ProcessSelect(request) {
        return axiosGetAuthorize(usp_Master_ProcessSelect, request);
    }

    async usp_Master_ItemSelectbyIDCategory(request) {
        return axiosPostAuthorize(usp_Master_ItemSelectbyIDCategory, request);
    }

    async usp_Master_ItemSelectbyID_JobWork(request) {
        return axiosPostAuthorize(usp_Master_ItemSelectbyID_JobWork, request);
    }

    async submitMaterialJobWorkInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_MaterialJobWorkInsertUpdate, request);
    }

    async getTransactionMaterialJobWorkSelectbyID(request) {
        return axiosGetAuthorize(GetTransactionMaterialJobWorkSelectbyID, request);
    }

    async getTransactionMaterialJobWorkItemsSelectbyID(request) {
        return axiosGetAuthorize(GetTransactionMaterialJobWorkItemsSelectbyID, request);
    }

    async downloadMaterialJobWorkInvoice(request) {
        return axiosGetFileAuthorizeblob(DownloadMaterialJobWorkInvoice, request);
    }

    async downloadPendingMaterialJobWorkInvoice(request) {
        return axiosGetFileAuthorizeblob(DownloadPendingMaterialJobWorkInvoice, request);
    }

    // Job Work Inward
    async usp_Extra_GatePassSelect_ForJobWorkInward(request) {
        return axiosPostAuthorize(USP_Extra_GatePassSelect_ForJobWorkInward, request);
    }

    async getInvoiceCountForJobWorkInward(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialJobWorkInwardCOUNT, request);
    }

    async usp_Transaction_MaterialJobWorkSelectbyIDVendor2(request) {
        return axiosPostAuthorize(usp_Transaction_MaterialJobWorkSelectbyIDVendor2, request);
    }

    async usp_Transaction_MaterialJobWorkSelectbyID_PendingQty(request) {
        return axiosPostAuthorize(usp_Transaction_MaterialJobWorkSelectbyID_PendingQty, request);
    }

    async addProductForMaterialInward(request) {
        return axiosPostAuthorize(AddProductForMaterialInward, request);
    }

    async submitJobWorkInwardInsertUpdate(request) {
        return axiosPostAuthorize(SubmitJobWorkInwardInsertUpdate, request);
    }

    async usp_Transaction_MaterialJobWorkInwardSelectbyID(request) {
        return axiosGetAuthorize(USP_Transaction_MaterialJobWorkInwardSelectbyID, request);
    }

    async usp_Transaction_MaterialJobWorkInwardItemsSelectbyID(request) {
        return axiosGetAuthorize(USP_Transaction_MaterialJobWorkInwardItemsSelectbyID, request);
    }

    async downloadJobWorkInwardInvoice(request) {
        return axiosGetFileAuthorizeblob(DownloadJobWorkInwardInvoice, request);
    }

    async usp_Transaction_JobworkInwardDelete(request) {
        return axiosGetAuthorize(usp_Transaction_JobworkInwardDelete, request);
    }
    // async sendPurchaseInvoiceMail(request) {
    //     return axiosGetMultiParams(SendPurchaseInvoiceMail, request);
    // }
    // async shareOnWhatsApp(request) {
    //     return axiosGetAuthorize(ShareOnWhatsApp, request);
    // }


    // Purchase Order
    async getAllDropdown(request) {
        return axiosGetMultiParams(GetAllDropdownAndCountsForTransactionStock, request);
    }
    async usp_Transaction_PurchaseOrderCount(request) {
        return axiosGetMultiParams(usp_Transaction_PurchaseOrderCount, request);
    }
    async getMaster_TaxStructure(request) {
        return axiosGetAuthorize(GetMaster_TaxStructure, request);
    }
    async getMasterItemSelectbyItemTypeVendorwise(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectbyItemType_Vendorwise, request);
    }
    async getMasterItemSelectbyIDVendorwiseRate(request) {
        return axiosGetMultiParams(USP_Master_ItemSelectbyID_VendorwiseRate, request);
    }
    async submitPurchaseOrder(request) {
        return axiosPostAuthorize(USP_Transaction_PurchaseOrderInsertUpdate, request);
    }
    async getTransactionPurchaseOrderSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_PurchaseOrderSelectbyId, request);
    }
    async getPurchaseInquirySelectNotinPurchaseOrder2(request) {
        return axiosGetMultiParams(usp_Transaction_PurchaseInquirySelectNotinPurchaseOrder2, request);
    }
    async getPurchaseInquirySelectbyIDNotInPurchaseOrderItems2(request) {
        return axiosGetMultiParams(USP_Transaction_PurchaseInquirySelectbyIDNotInPurchaseOrderItems2, request);
    }
    async getItemRateVendorwiseSelect3(request) {
        return axiosGetAuthorize(USP_Master_ItemRateVendorwiseSelect3, request);
    }
    async getPurchaseInquirySelectbyIDNotInPurchaseOrderItems(request) {
        return axiosGetMultiParams(USP_Transaction_PurchaseInquirySelectbyIDNotInPurchaseOrderItems, request);
    }
    async downloadPurchaseInvoice(request) {
        return axiosGetFileAuthorizeblob(DownloadPurchaseInvoice, request);
    }
    async generatePendingPurchaseOrderInvoice(request) {
        return axiosGetFileAuthorizeblob(GeneratePendingPurchaseOrderInvoice, request);
    }
    async sendPurchaseInvoiceMail(request) {
        return axiosGetMultiParams(SendPurchaseInvoiceMail, request);
    }
    async shareOnWhatsApp(request) {
        return axiosGetMultiParams(ShareOnWhatsApp, request);
    }

    // Material Purchase 
    async getExtraGatePassSelectForPurchase(request) {
        return axiosGetMultiParams(USP_Extra_GatePassSelect_ForPurchase, request);
    }
    async submitPurchaseInwardInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_PurchaseInwardInsertUpdate, request);
    }
    async getTransactionPurchaseInwardSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_PurchaseInwardSelectbyId, request);
    }
    async getTransaction_PurchaseOrderSelectbyIDVendor(request) {
        return axiosGetMultiParams(USP_Transaction_PurchaseOrderSelectbyIDVendor, request);
    }
    async USP_Transaction_PurchaseOrderSelectbyID_PendingQty(request) {
        return axiosGetMultiParams(USP_Transaction_PurchaseOrderSelectbyID_PendingQty, request);
    }
    async getPartyAccountSelectbyID_withGatePass(request) {
        return axiosGetMultiParams(USP_Master_PartyAccountSelectbyID_withGatePass, request);
    }
    async generateMaterialPurchaseReport(request) {
        return axiosGetFileAuthorizeblob(GenerateMaterialPurchaseReport, request);
    }

    // Material Testing
    async getInvoiceCountForMaterialTesting(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialTestingCount, request);
    }

    async usp_Transaction_PurchaseInwardSelectbyIDVendorNotInMaterialTesting(request) {
        return axiosPostAuthorize(usp_Transaction_PurchaseInwardSelectbyIDVendorNotInMaterialTesting, request);
    }

    async usp_Transaction_PurchaseInwardSelectIDVendorNotInMaterialTesting(request) {
        return axiosPostAuthorize(usp_Transaction_PurchaseInwardSelectIDVendorNotInMaterialTesting, request);
    }

    async submitMaterialTestingInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_MaterialTestingInsertUpdate, request);
    }

    async getTransactionMaterialTestingSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_MaterialTestingSelectbyId, request);
    }


    // Material Planning 
    async usp_Master_PartyAccountSelectCustomerForPlanning(request) {
        return axiosGetMultiParams(USP_Master_PartyAccountSelectCustomerForPlanning, request);
    }
    async usp_Master_PartyAccountSelectCustomerForCalculatePlanning(request) {
        return axiosGetAuthorize(USP_Master_PartyAccountSelectCustomerForCalculatePlanning, request);
    }
    async usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning(request) {
        return axiosGetMultiParams(usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning, request);
    }
    async usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning(request) {
        return axiosGetMultiParams(USP_Transaction_WorkOrderRecvSelectbyId_ForMaterialPlanning, request);
    }
    async usp_Transaction_WorkOrderProductsSelect(request) {
        return axiosGetAuthorize(USP_Transaction_WorkOrderProductsSelect, request);
    }
    async usp_Transaction_WorkOrderRecvProductsSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_WorkOrderRecvProductsSelectbyId, request);
    }
    async usp_Master_ProductReceipeSelect_ForWOItem(request) {
        return axiosGetMultiParams(USP_Master_ProductReceipeSelect_ForWOItem, request);
    }
    async usp_Master_ProductReceipeSelect_ForWOItem_ForExisitingItem(request) {
        return axiosGetMultiParams(USP_Master_ProductReceipeSelect_ForWOItem_ForExisitingItem, request);
    }
    async usp_Transaction_MaterialPlanningInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_MaterialPlanningInsertUpdate, request);
    }
    async usp_Transaction_MaterialPlanningSelectbyId2(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialPlanningSelectbyId2, request);
    }
    async addWoBomData(request) {
        return axiosGetMultiParams(AddWoBomData, request);
    }

    // Material Job Work
    async usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning2(request) {
        return axiosGetMultiParams(usp_Transaction_WorkOrderRecvSelectbyIdCustomer_NotinMateralPlanning2, request);
    }
    async usp_Transaction_MaterialPlanningSelectbyId(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialPlanningSelectbyId, request);
    }
    async usp_Transaction_MaterialPlanning_MultipleInsertUpdate(request) {
        return axiosPostAuthorize(usp_Transaction_MaterialPlanning_MultipleInsertUpdate, request);
    }
    async usp_Transaction_MaterialPlanning_MultipleSelectByID(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialPlanning_MultipleSelectByID, request);
    }

    // Purchase Inquiry 
    async usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry(request) {
        return axiosGetMultiParams(usp_Transaction_WorkOrderRecvSelectForPurchaseInquiry, request);
    }
    async usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForPurchaseInquiry(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForPurchaseInquiry, request);
    }
    async usp_Transaction_PurchaseInquiryInsertUpdate(request) {
        return axiosPostAuthorize(usp_Transaction_PurchaseInquiryInsertUpdate, request);
    }
    async usp_Transaction_PurchaseInquirySelectbyId(request) {
        return axiosGetAuthorize(usp_Transaction_PurchaseInquirySelectbyId, request);
    }

    // working planning 
    async usp_Transaction_WorkOrderRecvSelectForWorkPlanning(request) {
        return axiosGetMultiParams(usp_Transaction_WorkOrderRecvSelectForWorkPlanning, request);
    }
    async usp_Transaction_MaterialPlanningSelectbyIDWorkOrder(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialPlanningSelectbyIDWorkOrder, request);
    }
    async usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForWorkPlanning(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialPlanningSelectbyIDWorkOrder_ForWorkPlanning, request);
    }
    async usp_Transaction_WorkPlanningInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_WorkPlanningInsertUpdate, request);
    }
    async usp_Transaction_WorkPlanningSelectbyId(request) {
        return axiosGetAuthorize(usp_Transaction_WorkPlanningSelectbyId, request);
    }

    // Material Issue
    async usp_Transaction_MaterialProductionSelectNotinMaterialIssue(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialProductionSelectNotinMaterialIssue, request);
    }
    async usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialProductionSelectByIDNotInMaterialIssueItems, request);
    }
    async usp_Transaction_MaterialIssueInsertUpdate(request) {
        return axiosPostAuthorize(USP_Transaction_MaterialIssueInsertUpdate, request);
    }
    async usp_Transaction_MaterialIssueSelectbyId(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialIssueSelectbyId, request);
    }
    async usp_Transaction_StoreToPlantDataSelectByItemId(request) {
        return axiosGetMultiParams(usp_Transaction_StoreToPlantDataSelectByItemId, request);
    }

    // Material Production
    async usp_Transaction_WorkOrderRecvSelect_NotInMaterialProduction(request) {
        return axiosGetMultiParams(usp_Transaction_WorkOrderRecvSelect_NotInMaterialProduction, request);
    }
    async usp_Transaction_WorkPlanningSelectNotinMaterialProduction(request) {
        return axiosGetMultiParams(usp_Transaction_WorkPlanningSelectNotinMaterialProduction, request);
    }
    async usp_Transaction_WorkPlannigSelectbyId_ForMaterialProduction(request) {
        return axiosGetMultiParams(usp_Transaction_WorkPlannigSelectbyId_ForMaterialProduction, request);
    }
    async usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialProduction(request) {
        return axiosGetMultiParams(usp_Transaction_WorkOrderRecvSelectbyId_ForMaterialProduction, request);
    }
    async usp_Transaction_WorkPlanningItemQuantitySelect_ForMaterialProduction(request) {
        return axiosGetAuthorize(usp_Transaction_WorkPlanningItemQuantitySelect_ForMaterialProduction, request);
    }
    async usp_Transaction_WorkOrderRecvItemQuantitySelect_ForMaterialProduction(request) {
        return axiosGetAuthorize(usp_Transaction_WorkOrderRecvItemQuantitySelect_ForMaterialProduction, request);
    }
    async usp_Master_ProductReceipeSelectbyIdforMaterialProduction(request) {
        return axiosGetAuthorize(usp_Master_ProductReceipeSelectbyIdforMaterialProduction, request);
    }
    async usp_Master_ProductReceipeSelectbyIdforMaterialProductionWO(request) {
        return axiosGetAuthorize(usp_Master_ProductReceipeSelectbyIdforMaterialProductionWO, request);
    }
    async usp_Transaction_MaterialProductionInsetUpdate(request) {
        return axiosPostAuthorize(usp_Transaction_MaterialProductionInsetUpdate, request);
    }
    async usp_Transaction_MaterialProductionSelectbyId(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialProductionSelectbyId, request);
    }
    async usp_Transaction_WorkPlanningSelect_Pending_WithNewChanges(request) {
        return axiosGetAuthorize(usp_Transaction_WorkPlanningSelect_Pending_WithNewChanges, request);
    }

    // Issue Process Transaction
    async usp_Transaction_IssueProcessTransactionCount(request) {
        return axiosGetAuthorize(usp_Transaction_IssueProcessTransactionCount, request);
    }
    async usp_Transaction_MaterialProductionNoSelectNotinIssueProcessTransaction2(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialProductionNoSelectNotinIssueProcessTransaction2, request);
    }
    async usp_Transaction_MaterialIssue_JobWorkSelectPendingItem(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialIssue_JobWorkSelectPendingItem, request);
    }
    async usp_Transaction_MaterialProductionItemQuantitySelect_ForMaterialIssueProcess(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialProductionItemQuantitySelect_ForMaterialIssueProcess, request);
    }
    async usp_Transaction_MaterialProduction_Serial_Select_ForAssembly(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialProduction_Serial_Select_ForAssembly, request);
    }
    async usp_Master_ProcessItemSelectbyIDItem(request) {
        return axiosGetMultiParams(usp_Master_ProcessItemSelectbyIDItem, request);
    }
    async usp_Transaction_MaterialIssue_JobWorkSelectbyID(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialIssue_JobWorkSelectbyID, request);
    }
    async usp_Transaction_MaterialProduction_SerialNoSelectbyID(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialProduction_SerialNoSelectbyID, request);
    }
    async usp_Transaction_MaterialIssue_JobWorkInsertUpdate(request) {
        return axiosPostAuthorize(usp_Transaction_MaterialIssue_JobWorkInsertUpdate, request);
    }
    async usp_Master_EmployeeSelect_ForIssueJobWorkProcessWise(request) {
        return axiosGetMultiParams(usp_Master_EmployeeSelect_ForIssueJobWorkProcessWise, request);
    }
    async addAllocatedQtyEmployeeWise(request) {
        return axiosPostAuthorize(AddAllocatedQtyEmployeeWise, request);
    }
    async getAllocatedQtyEmployeeWise(request) {
        return axiosGetMultiParams(GetAllocatedQtyEmployeeWise, request);
    }
    async usp_Transaction_MaterialIssue_JobWorkRecordDelete(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialIssue_JobWorkRecordDelete, request);
    }
    async downloadIssueProcessEmployeeReport(request) {
        return axiosGetFileAuthorizeblob(DownloadIssueProcessEmployeeReport, request);
    }

    // Material Rejection
    async usp_Transaction_MaterialRejectionCount(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialRejectionCount, request);
    }
    // Material Rejection Outward
    async usp_Transaction_MaterialRejectionOutwardCount(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialRejectionOutwardCount, request);
    }
    async usp_Transaction_MaterialRejectionSelect_ForOutward(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialRejectionSelect_ForOutward, request);
    }
    async usp_Transaction_MaterialRejectionItemSelect_ForOutward(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialRejectionItemSelect_ForOutward, request);
    }
    async usp_Transaction_MaterialRejectionItemSelect_ForOutward_ByMaterial(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialRejectionItemSelect_ForOutward_ByMaterial, request);
    }
    async usp_Master_MaterialSelect_ForOutward(request) {
        return axiosGetAuthorize(usp_Master_MaterialSelect_ForOutward, request);
    }
    // Purchase Inquiry Outward
    async usp_Transaction_PurchaseInquiryOutwardCount(request) {
        return axiosGetAuthorize(usp_Transaction_PurchaseInquiryOutwardCount, request);
    }
    async usp_Master_ItemSelect_ForPurchaseInquiryOutward(request) {
        return axiosGetAuthorize(usp_Master_ItemSelect_ForPurchaseInquiryOutward, request);
    }
    async usp_Transaction_PurchaseInquirySelect_ForOutward_ByItem(request) {
        return axiosGetMultiParams(usp_Transaction_PurchaseInquirySelect_ForOutward_ByItem, request);
    }
    async submitPurchaseInquiryOutward(request) {
        return axiosPostAuthorize(USP_Transaction_PurchaseInquiryOutwardInsertUpdate, request);
    }
    async usp_Transaction_PurchaseInquiryOutwardSelectbyId(request) {
        return axiosGetAuthorize(usp_Transaction_PurchaseInquiryOutwardSelectbyId, request);
    }
    async submitMaterialRejectionOutward(request) {
        return axiosPostAuthorize(USP_Transaction_MaterialRejectionOutwardInsertUpdate, request);
    }
    async usp_Transaction_MaterialRejectionOutwardSelectbyId(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialRejectionOutwardSelectbyId, request);
    }
    async usp_Master_PartyAccountSelectSupplier(request) {
        return axiosGetAuthorize(usp_Master_PartyAccountSelectSupplier, request);
    }
    async usp_Master_ItemSelectForAuto(request) {
        return axiosGetAuthorize(usp_Master_ItemSelectForAuto, request);
    }
    async submitMaterialRejection(request) {
        return axiosPostAuthorize(USP_Transaction_MaterialRejectionInsertUpdate, request);
    }
    async getMaterialRejectionSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_MaterialRejectionSelectbyId, request);
    }

    // Sales Return
    async usp_Transaction_SalesReturnCount(request) {
        return axiosGetAuthorize(usp_Transaction_SalesReturnCount, request);
    }
    async usp_Master_PartyAccountSelectCustomer(request) {
        return axiosGetAuthorize(usp_Master_PartyAccountSelectCustomer, request);
    }
    async usp_Transaction_SalesInvoiceSelect_ForSalesReturn(request) {
        return axiosGetMultiParams(usp_Transaction_SalesInvoiceSelect_ForSalesReturn, request);
    }
    async submitSalesReturn(request) {
        return axiosPostAuthorize(USP_Transaction_SalesReturnInsertUpdate, request);
    }
    async getSalesReturnSelectbyId(request) {
        return axiosGetAuthorize(usp_Transaction_SalesReturnSelectbyId, request);
    }

    // Sales Return Inward
    async getCountForSalesReturnInward(request) {
        return axiosGetAuthorize(usp_Transaction_SalesReturnInwardCOUNT, request);
    }
    async getTransaction_SalesReturnSelectbyIDVendor(request) {
        return axiosGetMultiParams(USP_Transaction_SalesReturnSelectbyIDVendor, request);
    }
    async USP_Transaction_SalesReturnSelectbyID_PendingQty(request) {
        return axiosGetMultiParams(USP_Transaction_SalesReturnSelectbyID_PendingQty, request);
    }
    async submitSalesReturnInwardInsertUpdate(request) {
        return axiosPostAuthorize(SubmitSalesReturnInwardInsertUpdate, request);
    }
    async getTransactionSalesReturnInwardSelectbyId(request) {
        return axiosGetAuthorize(USP_Transaction_SalesReturnInwardSelectbyId, request);
    }
    async usp_Master_PartyAccountSelectCustomerForSalesReturnInward(request) {
        return axiosGetMultiParams(USP_Master_PartyAccountSelectCustomerForSalesReturnInward, request);
    }

    // Rework Product
    async usp_Transaction_MaterialJobWorkSelect_ForRework(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialJobWorkSelect_ForRework, request);
    }
    async usp_Master_ItemSelect(request) {
        return axiosGetAuthorize(usp_Master_ItemSelect, request);
    }
    async usp_Transaction_ReworkCount(request) {
        return axiosGetAuthorize(usp_Transaction_ReworkCount, request);
    }
    async usp_Transaction_MaterialJobWorkSelectByID(request) {
        return axiosGetAuthorize(usp_Transaction_MaterialJobWorkSelectByID, request);
    }
    async usp_Transaction_MaterialJobWorkItemSelectByIDMaterialJobWork(request) {
        return axiosGetMultiParams(usp_Transaction_MaterialJobWorkItemSelectByIDMaterialJobWork, request);
    }
    async usp_Transaction_JobWorkQuantitySelectbyIDMaterialJobWorkItems(request) {
        return axiosGetAuthorize(usp_Transaction_JobWorkQuantitySelectbyIDMaterialJobWorkItems, request);
    }
    async getReworkBOMItems(request) {
        return axiosGetMultiParams(getReworkBOMItems, request);
    }
    async saveOrUpdateRework(request) {
        return axiosPostAuthorize(saveOrUpdateRework, request);
    }
    async getReworkById(request) {
        return axiosGetAuthorize(GetReworkById, request);
    }
    async generateReportForReworkProduct(request) {
        return axiosGetFileAuthorizeblob(GenerateReportForReworkProduct, request);
    }
}